module.exports = __webpack_public_path__ + "img/treasury.b552f1ad.png";